// @flow

import { DraftLiveStateEnum } from "@modules/service/constants";
import type { AbsenceMonitoringState } from "./types";

export const initialState: AbsenceMonitoringState = {
  requestsInProgress: 0,
  schema: {},
  list: [],
  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  configuration: {
    enabled: true,
    status: DraftLiveStateEnum.LIVE,
  },
  modals: {
    modalStep: 1,
    showAddModal: false,
    showEditModal: false,
    showEditAssignmentsModal: false,
    showDiscardModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
  },
};

export default initialState;
